import { render, staticRenderFns } from "./partner-form-responsible-area.vue?vue&type=template&id=13bab39a"
import script from "./partner-form-responsible-area.vue?vue&type=script&lang=js"
export * from "./partner-form-responsible-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports